export const iconFontAwesomeMoneyMoneyCheckDollar = (
	<i className="fa-solid fa-money-check-dollar"></i>
);
